import React from 'react';
import styled from 'styled-components';

export const HorizontalLine = styled.div`
    &&& {
        border: 1px solid #f5f5f5;
        margin: 8px -10px 0 -13px;
    }
`;
